export default __webpack_public_path__ + "static/oktane20-og-cfb2e557794b164db39df2705037cad7.png";